import { Controller } from "@hotwired/stimulus"

// Handles amenity category form submission and redirection
export default class extends Controller {
  static values = {
    successUrl: String
  }

  handleSubmit(event) {
    if (event.detail?.success) {
      Turbo.visit(this.successUrlValue)
    }
  }
}
